export * from '@gen/wklr-backend-api/v1/model/index';
